import { Link, useLocation } from "react-router-dom";
import Button from "@mui/material/Button";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { useState } from "react";
import logo from "../assets/logo.jpeg";
import "./Navbar.css";

function Navbar() {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navLinks = [
    { name: "Home", path: "/" },
    { name: "I & C", path: "/i-c" },
    { name: "Solutions", path: "/solutions" },
    { name: "Services", path: "/pricing" },
    { name: "About", path: "/about" },
    { name: "Gallery", path: "/gallery" },
    { name: "Contact", path: "/contact" },
  ];

  return (
    <header className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <img src={logo} alt="Solar Logo" height={42} width={42} />
          Solar
        </Link>

        <nav className="nav-links">
          {navLinks.map((link) => {
            const isActive = location.pathname === link.path;

            return (
              <Link key={link.name} to={link.path} className="nav-link">
                {isActive && (
                  <motion.span
                    layoutId="active-pill"
                    className="active-pill"
                    transition={{
                      type: "spring",
                      stiffness: 400,
                      damping: 30,
                    }}
                  />
                )}
                <span className={`nav-text ${isActive ? "active" : ""}`}>
                  {link.name}
                </span>
              </Link>
            );
          })}
        </nav>

        <div className="nav-right">
          <Button
            variant="contained"
            className="cta-button"
            component={Link}
            to="/quote"
          >
            Get Quote
          </Button>
          <button
            className="mobile-menu-btn"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <motion.nav
            className="mobile-menu"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ type: "spring", stiffness: 300, damping: 30 }}
          >
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                className="mobile-menu-link"
                onClick={() => setMobileMenuOpen(false)}
              >
                {link.name}
              </Link>
            ))}
          </motion.nav>
        )}
      </div>
    </header>
  );
}

export default Navbar;
